import { Button } from '@material-ui/core';
import { IconTrash } from '@tabler/icons';

import { useDialog } from '#root/hooks';
import RejectDialog from '#root/components/DealCard/RejectDialog';
import styles from './actions.module.scss';

const Actions = (props) => {
  const { dealIda, handleLoading, createMessage } = props;
  const rejectDialog = useDialog();

  const openRejectAlert = () => {
    // handleMenuClose();
    rejectDialog.openDialog();
  };

  return (
    <div className={styles.root}>
      <Button
        className={styles.btn}
        startIcon={<IconTrash size={20} color="var(--color-status-error)" />}
        onClick={openRejectAlert}>
        Rechazar acuerdo
      </Button>
      <RejectDialog
        id={dealIda}
        open={rejectDialog.open}
        onClose={rejectDialog.closeDialog}
        handleLoading={handleLoading}
        createMessage={createMessage}
      />
    </div>
  );
};

export default Actions;
